import CATEGORIES from '../api/endpoints/categories';
import apiClient from '../api/apiClient';

// Fetch professions optionally filtered by type
export const getCategories = async (type) => {
  try {
    const response = await apiClient.get(CATEGORIES.GET_CATEGORIES, {
      params: { type }, // adds ?type=freelancer or ?type=business
    });
    return response.data; // array of professions
  } catch (error) {
    console.error("Failed to fetch professions:", error);
    throw error;
  }
};

export const getAllServiceProviders = async ({
  type,
  page = 1,
  page_size = 20,
  category = null,
  location = null,
  search = null,
} = {}) => {
  try {
    const params = { type, page, page_size };

    if (category) params.category = category;
    if (location) params.location = location;
    if (search) params.search = search;

    const response = await apiClient.get(CATEGORIES.ALL_SERVICE_PROVIDERS, {
      params,
    });

    return response.data;
  } catch (err) {
    console.error("Error fetching service providers:", err);
    return { results: [], count: 0 };
  }
};

// 🔍 Search service providers (for search results page)
export const searchServiceProviders = async (query, extraFilters = {}) => {
  try {
    const params = { q: query, ...extraFilters }; 
    const response = await apiClient.get(CATEGORIES.SEARCH, { params });
    return response.data;
  } catch (error) {
    console.error("Failed to search service providers:", error);
    throw error;
  }
};